import React from "react";
import { OperationType } from "../common/operationTypes";
import { getOperationParams } from "../common/utilities";
import { Labeled } from "react-admin";
import restClient from "../common/restClient";

class ExtraVarsFields extends React.Component {
    state = {
        user_params: null,
        data_db: null,
        customer_vatin: null,
        company_vatin: null
    };

    componentDidMount() {
        getOperationParams(
            this.props.record.installation_type_id,
            OperationType.Installation
        ).then(params =>
            this.setState({
                user_params: params.user_prompt,
                data_db: params.data_db
            })
        );
        restClient("GET_ONE", "companies", {
            id: this.props.record.company_id
        }).then(
            result => {
                if (result && result.data) {
                    this.setState({
                        company_vatin: result.data.vatin
                    });
                }
            },
            err => {
                console.log(err);
                return null;
            }
        );
        restClient("GET_ONE", "customers", {
            id: this.props.record.customer_id
        }).then(
            result => {
                if (result && result.data) {
                    this.setState({
                        customer_vatin: result.data.vatin
                    });
                }
            },
            err => {
                console.log(err);
                return null;
            }
        );
    }

    renderOptionalUserParams() {
        let extravars = this.props.record.extra_vars;
        if (
            this.state.user_params != null &&
            this.state.user_params !== "" &&
            extravars != null &&
            Object.keys(extravars).length === 0
        ) {
            return this.state.user_params.map(element => {
                if (element.viewable) {
                    return (
                        <div>
                            <Labeled label={element.label}>
                                <span> {extravars[element.name]}</span>
                            </Labeled>
                        </div>
                    );
                } else {
                    return null;
                }
            });
        }
    }

    renderOptionalDbParams() {
        if (this.state.data_db != null && this.state.data_db !== "") {
            return this.state.data_db.map(element => {
                if (element.viewable) {
                    if (element.reference === "companies_vatin") {
                        return (
                            <div>
                                <Labeled label={element.label}>
                                    <span>{this.state.company_vatin}</span>
                                </Labeled>
                            </div>
                        );
                    } else if (element.reference === "customers_vatin") {
                        return (
                            <div>
                                <Labeled label={element.label}>
                                    <span>{this.state.customer_vatin}</span>
                                </Labeled>
                            </div>
                        );
                    } else {
                        return null;
                    }
                } else {
                    return null;
                }
            });
        }
    }

    render() {
        return (
            <div>
                {this.renderOptionalUserParams()}
                {this.renderOptionalDbParams()}
            </div>
        );
    }
}

export default ExtraVarsFields;



// WEBPACK FOOTER //
// ./src/components/ExtraVarsFields.js